import {Tabs, TabsList, TabsTrigger} from "@/components/ui/tabs";
import {Archive, AlertTriangle, Calendar, Clock, Users} from "lucide-react";
import type {TabType} from "@/hooks/usePeopleUI";

const tabs: { value: TabType; label: string; icon: any }[] = [
    {value: "all", label: "Все", icon: Users},
    {value: "pending", label: "В процессе", icon: Clock},
    {value: "today", label: "Выплаты сегодня", icon: Calendar},
    {value: "overdue", label: "Просрочено", icon: AlertTriangle},
    {value: "archive", label: "Архив", icon: Archive},
];

export function ClientTabs({
                               activeTab,
                               onTabChange,
                           }: {
    activeTab: TabType;
    onTabChange: (t: TabType) => void;
}) {
    return (
        <Tabs value={activeTab} onValueChange={(v) => onTabChange(v as TabType)}>
            <TabsList className="grid w-full grid-cols-5 lg:w-auto lg:inline-grid">
                {tabs.map((t) => (
                    <TabsTrigger key={t.value} value={t.value} asChild>
                        <button type="button" className="flex items-center gap-2">
                            <t.icon className="h-4 w-4"/>
                            <span className="hidden sm:inline">{t.label}</span>
                        </button>
                    </TabsTrigger>
                ))}
            </TabsList>
        </Tabs>
    );
}
